/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { ReactElement, useState } from 'react';

import Arrow from 'src/assets/arrow-left-black.svg';
import { useTranslation } from 'react-i18next';
import {
  ArrowBack,
  BackButton,
  BackButtonItems,
  BackText,
  Container,
  ContentContainer,
  FooterContainer,
  FooterItemLeft,
  HorizontalLine,
  NextButton,
  StepsContainer,
  StepsTextContainer,
} from './styles';

export type EnrollmentSteps = {
  title: string;
  subtitle: string;
  content: ReactElement;
  available: boolean;
};

export const EnrollmentWizard: React.FC<{
  steps: EnrollmentSteps[];
  submit: () => void;
  reviewEnabled?: boolean;
}> = ({ steps, submit, reviewEnabled = true }) => {
  const { t } = useTranslation();

  const [step, setStep] = useState(0);

  const previuosPageAvailable = step - 1 >= 0;
  const nextPageAvailable = step + 1 < steps.length;

  const handleNextPage = () => {
    const next = step + 1;
    if (!nextPageAvailable || !steps[next].available) {
      // console.log('next not available');
    } else {
      setStep(next);
    }
  };

  const handlePreviousPage = () => {
    const back = step - 1;
    if (!previuosPageAvailable) {
      //  console.log('back not available');
    } else {
      setStep(back);
    }
  };

  const handleReview = () => {
    submit();
  };

  return (
    <Container>
      <StepsContainer>
        {steps.map((stepItem, index) => (
          <>
            <StepsTextContainer active={index === step && stepItem.available} available={stepItem.available}>
              <div>{stepItem.title}</div>
              <div style={{ display: 'flex', width: 'max-content' }}>{stepItem.subtitle}</div>
            </StepsTextContainer>
            {index < steps.length - 1 && (
              <StepsTextContainer style={{ cursor: 'default' }} active={false} available={false}>
                <HorizontalLine />
              </StepsTextContainer>
            )}
          </>
        ))}
      </StepsContainer>

      <ContentContainer>{steps[step].content}</ContentContainer>
      <FooterContainer>
        <FooterItemLeft>
          {step !== 0 && (
            <BackButton onClick={handlePreviousPage}>
              <BackButtonItems>
                <ArrowBack src={Arrow} />
                <BackText>{t('global.button.back')}</BackText>
              </BackButtonItems>
            </BackButton>
          )}
        </FooterItemLeft>
        {nextPageAvailable ? (
          <NextButton type="button" onClick={handleNextPage}>
            {t('global.button.next')}
          </NextButton>
        ) : (
          <NextButton type="button" onClick={handleReview} disabled={!reviewEnabled}>
            {t('benefits.review.continueToReview')}
          </NextButton>
        )}
      </FooterContainer>
    </Container>
  );
};
